/*
 * ZAKU quick view — slide-in drawer with the PDP's gallery → spec table.
 *
 * - [data-quick-view="<product url>"] opens the drawer (its href stays as the no-JS fallback).
 * - Fetches <url>?section_id=main-product (Section Rendering API) once per product and keeps
 *   only the gallery / profile / buy box (.zk-mp-top) and the spec table (.zk-mp-specs).
 * - Wires the gallery arrows and the variant select locally (main-product's own script only
 *   runs on the PDP); ADD TO BAG is a [data-add-to-cart] form, so cart.js adds it and opens
 *   the cart drawer while this one closes.
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-quick-view-drawer]');
  if (!drawer) return;
  var body = drawer.querySelector('[data-quick-view-body]');
  var moreTpl = drawer.querySelector('[data-quick-view-more]');
  var cache = {};
  var lastFocus = null;
  var seq = 0;

  function open(url) {
    lastFocus = document.activeElement;
    var header = document.querySelector('.zk-header');
    drawer.style.top = header ? Math.max(0, header.getBoundingClientRect().bottom) + 'px' : '';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.zk-qv__close');
    if (close) close.focus();
    load(url);
  }
  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function status(html) { body.innerHTML = '<p class="zk-qv__status">' + html + '</p>'; }

  function load(url) {
    var mine = ++seq;
    body.scrollTop = 0;
    if (cache[url]) { render(url, cache[url]); return; }
    status('Loading…');
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', 'main-product');
    fetch(u.href)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        cache[url] = html;
        if (mine === seq) render(url, html);
      })
      .catch(function () {
        if (mine === seq) status('Could not load this product. <a href="' + url + '">Open the product page</a>');
      });
  }

  function render(url, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var mp = doc.querySelector('.zk-mp');
    if (!mp) { status('<a href="' + url + '">Open the product page</a>'); return; }
    var keep = mp.querySelector('.zk-mp-top');
    var specs = mp.querySelector('.zk-mp-specs');
    var variants = mp.querySelector('[data-zk-variants]');
    Array.prototype.slice.call(mp.children).forEach(function (c) { mp.removeChild(c); });
    [keep, variants, specs].forEach(function (n) { if (n) mp.appendChild(n); });
    mp.classList.remove('full-width');
    // The PDP may be open underneath: keep ids unique
    mp.querySelectorAll('[id]').forEach(function (el) { el.id = 'zk-qv-' + el.id; });
    mp.querySelectorAll('label[for]').forEach(function (el) { el.htmlFor = 'zk-qv-' + el.htmlFor; });
    mp.querySelectorAll('h1').forEach(function (h) {
      var p = document.createElement('h2');
      p.className = h.className; p.innerHTML = h.innerHTML;
      h.replaceWith(p);
    });

    body.innerHTML = '';
    body.appendChild(mp);
    if (moreTpl) {
      var more = moreTpl.content.cloneNode(true);
      var a = more.querySelector('a');
      if (a) a.href = url;
      body.appendChild(more);
    }
    initGallery(mp);
    initVariants(mp);
  }

  function initGallery(root) {
    if (window.zkGallery) window.zkGallery(root.querySelector('[data-gallery]'));
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-zk-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var track = root.querySelector('[data-gallery-track]');
    root.querySelectorAll('[data-zk-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === sel.value; })[0];
        if (!v) return;
        var price = root.querySelector('[data-zk-price]'); if (price) price.textContent = v.price;
        var stock = root.querySelector('[data-zk-stock]');
        if (stock) {
          stock.innerHTML = '<span class="zk-mp-buy__dot' + (v.available ? '' : ' is-off') + '" aria-hidden="true"></span>' +
            (v.available ? '<span class="zk-mp-buy__stock">In Stock</span><span class="zk-mp-buy__stock zk-mp-buy__sep">/</span><span class="zk-mp-buy__stock">Ready to Ship</span>' : '<span class="zk-mp-buy__stock">Sold out</span>');
        }
        root.querySelectorAll('[data-zk-atb]').forEach(function (b) {
          b.disabled = !v.available;
          var l = b.querySelector('[data-zk-atb-label]'); if (l) l.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
        });
        if (track && v.featured_media_id) {
          var slide = track.querySelector('[data-media-id="' + v.featured_media_id + '"]');
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open(trigger.getAttribute('data-quick-view'));
      return;
    }
    if (e.target.closest('[data-quick-view-close]')) close();
  });
  // ADD TO BAG: cart.js handles the request and opens the cart drawer
  drawer.addEventListener('submit', function (e) {
    if (e.target.closest('form[data-add-to-cart]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
